// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sFrA","col":"styles_col__3_O60"};